import React from 'react';
import { useEffectOnce } from 'react-use';
import { useWorkflowNextMutation } from '../../api/useWorkflowNextMutation';
import { PageId, WorkflowIdEnum } from '../../api/useWorkflowDataQuery';
import { WorkflowLoading } from '../../Workflow.loading';
import { WorkflowError } from '../../Workflow.error';

interface Props {
  clientId: string;
  workflowId: WorkflowIdEnum;
}

export const WorkflowStart: React.FC<Props> = ({ clientId, workflowId }) => {
  const { mutateAsync: workflowNext, isLoading, isError } = useWorkflowNextMutation({ clientId });

  const onWorkflowNext = async () => {
    try {
      const { Route } = await workflowNext({ clientId, stepId: PageId.Start, workflowId });

      if (Route.Name === 'Workflow') {
        ADV.util.Router.go2('Workflow', Route.Params);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffectOnce(() => {
    onWorkflowNext();
  });

  if (isLoading) {
    return <WorkflowLoading />;
  }

  if (isError) {
    return <WorkflowError onRetry={onWorkflowNext} />;
  }

  return null;
};
